import React from 'react';
import { VStack } from 'native-base';
import { useSpringBigStore, useTheme } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import SentGift from '../assets/SentGift';

const SentMessage = ({ data }: { data: any }) => {

    const { merchant } = useSpringBigStore();

    const { primary } = useTheme();

    return (
        <VStack alignItems='center' space={8}>
            <Caption
                text={'giftCard.send.sent.title'}
                textValues={[merchant?.gift_card_alias]}
                fontSize={24}
            />
            <SentGift fill={primary} width={135} height={135} />
            <Caption
                text={'giftCard.send.sent.amount'}
                textValues={[data?.amount]}
                fontSize={24}
            />
            <Caption
                text={'giftCard.send.sent.to'}
                textValues={[data?.email]}
                fontSize={18}
            />
        </VStack>
    );
};

export default SentMessage;
